(() => {
  const SELECTOR_DRAWER = '[data-cm-cart-drawer]';
  const SECTION_ID = 'cm-cart-drawer';

  const drawer = document.querySelector(SELECTOR_DRAWER);
  if (!drawer) return;

  const moneyFormat = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.cmMoneyFormat);
    }
    return (cents / 100).toFixed(2) + ' kr.';
  };

  // Countdown timer: vis før 17:00, skjul efter 17:00
  const initCutoffTimer = () => {
    const el = drawer.querySelector('[data-cm-cutoff]');
    if (!el) return;

    const timeEl = el.querySelector('[data-cm-cutoff-time]');
    if (!timeEl) return;

    const cutoffHour = 17; // 17:00

    const tick = () => {
      const now = new Date();
      const secs =
        now.getHours() * 3600 +
        now.getMinutes() * 60 +
        now.getSeconds();

      const remaining = cutoffHour * 3600 - secs;

      if (remaining <= 0) {
        el.hidden = true;
        return;
      }

      el.hidden = false;

      const h = Math.floor(remaining / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;

      const pad = (n) => String(n).padStart(2, '0');
      timeEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
    };

    if (window.cmCutoffTimer) clearInterval(window.cmCutoffTimer);

    tick();
    window.cmCutoffTimer = setInterval(tick, 1000);
  };

  const openDrawer = () => {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cm-cart-drawer-open');
  };

  const closeDrawer = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cm-cart-drawer-open');
  };

  const setLoading = (isLoading) => {
    drawer.toggleAttribute('data-cm-loading', !!isLoading);
  };

  const replaceDrawerHTML = (html) => {
    const next = new DOMParser().parseFromString(html, 'text/html');
    const nextDrawer = next.querySelector(SELECTOR_DRAWER);
    if (!nextDrawer) throw new Error('Drawer markup not found in section HTML');

    // IMPORTANT: vi udskifter kun innerHTML (så "drawer" reference stadig er valid)
    drawer.innerHTML = nextDrawer.innerHTML;

    // Re-bind events + init timer igen efter rerender
    bindDrawerEvents();
  };

  const fetchDrawerSection = async () => {
    const url = `/?sections=${encodeURIComponent(SECTION_ID)}&t=${Date.now()}`;
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) throw new Error('Section fetch failed');

    const data = await res.json();
    if (!data || !data[SECTION_ID]) throw new Error('Section key missing in response');
    return data[SECTION_ID];
  };

  const applyTotalsFromCart = (cart) => {
    const totalEl = drawer.querySelector('[data-cm-cart-total]');
    if (totalEl) totalEl.textContent = moneyFormat(cart.total_price);

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  };

  // --- NEW: debounced refresh, så hurtige qty klik ikke spammer sections ---
  let refreshTimer = null;
  let refreshInFlight = false;

  const refreshDrawer = async () => {
    const html = await fetchDrawerSection();
    replaceDrawerHTML(html);
  };

  const refreshDrawerDebounced = async () => {
    clearTimeout(refreshTimer);
    return new Promise((resolve, reject) => {
      refreshTimer = setTimeout(async () => {
        if (refreshInFlight) return resolve(); // ignorer hvis en refresh allerede kører
        refreshInFlight = true;
        try {
          await refreshDrawer();
          resolve();
        } catch (e) {
          reject(e);
        } finally {
          refreshInFlight = false;
        }
      }, 60);
    });
  };

  // NEW: efter /cart/change skal vi have Liquid markup korrekt (rabat, "Pr styk" osv.)
  const refreshDrawerWithCart = async (cart) => {
    // Opdater totals/count med det samme (hurtigt UI), og refresh markup bagefter
    applyTotalsFromCart(cart);
    await refreshDrawerDebounced();
    openDrawer(); // keep open after rerender
  };

  const cartChange = async ({ line, quantity }) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  };

  // ✅ Cross sell helper: add variant by id (JSON)
  const addVariantById = async ({ id, quantity = 1 }) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
    });
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  };

  const addToCart = async (form) => {
    const fd = new FormData(form);

    openDrawer();
    setLoading(true);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    });

    if (!res.ok) {
      setLoading(false);
      form.submit();
      return;
    }

    try {
      await refreshDrawer();
    } finally {
      setLoading(false);
    }
  };

  // Intercept classic Shopify add-to-cart forms
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;

      if (form.querySelector('input[name="return_to"]')) return;

      e.preventDefault();
      addToCart(form).catch(() => form.submit());
    },
    true
  );

  const bindDrawerEvents = () => {
    const d = document.querySelector(SELECTOR_DRAWER);
    if (!d) return;

    d.querySelector('[data-cm-cart-overlay]')?.addEventListener('click', closeDrawer);
    d.querySelector('[data-cm-cart-close]')?.addEventListener('click', closeDrawer);

    // Remove = full refresh
    d.querySelectorAll('[data-cm-remove]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const line = Number(btn.getAttribute('data-line') || 0);
        if (!line) return;

        setLoading(true);
        try {
          await cartChange({ line, quantity: 0 });
          await refreshDrawer();
          openDrawer();
        } catch (_) {
          window.location.href = '/cart';
        } finally {
          setLoading(false);
        }
      });
    });

    // +/- buttons = change cart + refresh drawer (for korrekt rabat/Pr styk)
    d.querySelectorAll('[data-cm-qty]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const line = Number(btn.getAttribute('data-line') || 0);
        const delta = Number(btn.getAttribute('data-cm-qty') || 0);
        if (!line || !delta) return;

        const input = d.querySelector(`[data-cm-qty-input][data-line="${line}"]`);
        const current = Number(input?.value || 0);
        const next = Math.max(0, current + delta);

        if (input) input.value = String(next);

        setLoading(true);
        try {
          const cart = await cartChange({ line, quantity: next });
          await refreshDrawerWithCart(cart);
        } catch (_) {
          window.location.href = '/cart';
        } finally {
          setLoading(false);
        }
      });
    });

    // Qty input change = change cart + refresh drawer
    d.querySelectorAll('[data-cm-qty-input]').forEach((input) => {
      input.addEventListener('change', async () => {
        const line = Number(input.getAttribute('data-line') || 0);
        if (!line) return;

        const next = Math.max(0, Number(input.value || 0));
        input.value = String(next);

        setLoading(true);
        try {
          const cart = await cartChange({ line, quantity: next });
          await refreshDrawerWithCart(cart);
        } catch (_) {
          window.location.href = '/cart';
        } finally {
          setLoading(false);
        }
      });
    });

    // ✅ Cross sell add = add + full refresh
    d.querySelectorAll('[data-cm-crosssell-add]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const id = Number(btn.getAttribute('data-variant-id') || 0);
        if (!id || btn.disabled) return;

        const oldText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Tilføjer...';

        openDrawer();
        setLoading(true);

        try {
          await addVariantById({ id, quantity: 1 });
          await refreshDrawer();
          openDrawer();
        } catch (_) {
          btn.disabled = false;
          btn.textContent = oldText || '+ Tilføj';
          window.location.href = '/cart';
        } finally {
          setLoading(false);
        }
      });
    });

    // Init countdown efter hver (re)render
    initCutoffTimer();
  };

  // initial bind
  bindDrawerEvents();

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  // Header cart button hook (Pixel Union): open instantly, then refresh
  document.addEventListener(
    'click',
    async (e) => {
      const cartBtn = e.target.closest('[data-cart-button]');
      if (!cartBtn) return;

      if (e.metaKey || e.ctrlKey || cartBtn.target === '_blank') return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      openDrawer();
      setLoading(true);

      try {
        await refreshDrawer();
        openDrawer();
      } catch (_) {
        window.location.href = '/cart';
      } finally {
        setLoading(false);
      }
    },
    true
  );
})();